import ba_logo from "../../img/logo/ba_logo_long.svg?url";
import ca_logo from "../../img/logo/ca_logo_long.svg?url";
const CA = window["CA"] || {};
const facets: { category: Record<string, string>; range: Record<string, string> } = CA.facets || {};
export const config = {
  referenceUrl: CA.referenceUrl || "https://ref.cadamap.com",
  searchUrl: CA.searchUrl || "https://ref.cadamap.com",
  tileUrl: "https://tile.cadamap.com",
  site: CA.site,
  logo: CA.site?.prefix === "ba" ? ba_logo : ca_logo,
  facets: facets,
  facetMapping: { ...facets.category, ...facets.range },
  // Tarief per Eigendomsinformatie (KIK_INZAGE_COST_EUR); 0 op de ETO.
  kikInzageCostEur: Number(CA.kikInzageCostEur ?? "3.70"),
};
export const useConfig = () => config;
